document.addEventListener('submit', (event) => {
  const form = event.target.closest('[data-cart-drawer-discount-form]');
  if (!form) return;

  event.preventDefault();
  const input = form.querySelector('[name="discount_code"]');
  const error = form.querySelector('[data-cart-drawer-discount-error]');
  const code = input.value.trim();

  if (!code) {
    error.hidden = false;
    input.focus();
    return;
  }

  const discountUrl = new URL(form.dataset.discountUrl, window.location.origin);
  discountUrl.pathname = `${discountUrl.pathname}${encodeURIComponent(code)}`;
  discountUrl.searchParams.set('redirect', form.dataset.checkoutUrl);
  window.location.assign(discountUrl.toString());
});
